import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { X } from "lucide-react"
import { cn } from "../../lib/utils"

// Right-anchored inset panel over a scrim (shadcn "sheet" pattern, reduced
// to the one side this app uses). Composes the same Radix Dialog primitive
// as ui/Dialog — only the positioning differs.
const Sheet = DialogPrimitive.Root
const SheetClose = DialogPrimitive.Close

// `wide` fits a dense table (the purchase list's add panel) instead of a form.
const SheetContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & { wide?: boolean }
>(({ className, children, wide = false, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-foreground/40" />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        "fixed inset-y-2.5 right-2.5 z-50 flex max-w-[calc(100vw-20px)] flex-col gap-4",
        wide ? "w-[1180px]" : "w-[404px]",
        "overflow-y-auto rounded-lg border border-border bg-background p-6 shadow-md",
        className
      )}
      {...props}
    >
      {children}
      <DialogPrimitive.Close className="absolute right-4 top-4 rounded-sm text-muted-foreground opacity-60 transition-opacity hover:opacity-100 focus-visible:outline-hidden">
        <X className="size-4" />
        <span className="sr-only">Close</span>
      </DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
))
SheetContent.displayName = "SheetContent"

const SheetTitle = DialogPrimitive.Title
const SheetDescription = DialogPrimitive.Description

export { Sheet, SheetContent, SheetTitle, SheetDescription, SheetClose }
